import React, { Component } from "react";
import Header from "../../commons/Header/Header";
import {
  withStyles,
  Box,
  Typography,
  Button,
  TextField,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Add, Delete, Edit, Email, Phone, Business } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import dialCodes from "../../config/dialCodes";
import axios from "axios";
import { URL } from "../../config/config";
import { connect } from "react-redux";

class POCDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pocForm: {
        name: "",
        designation: "",
        email: "",
        phone: "",
        countryCode: "+91", // Default to India
      },
      pocs: [],
      alert: "",
      alertMessage: "",
      isModalOpen: false,
      editingPoc: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchPOCs();
  }

  fetchPOCs = async () => {
    try {
      this.setState({ loading: true });
      const response = await axios.get(`${URL}/api/parter-form-pocs`);

      this.setState({ pocs: response.data.pocs || [] });
    } catch (error) {
      console.error("Error fetching POCs:", error);
      this.setState({
        alert: "error",
        alertMessage: "Failed to load POCs. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleInputChange = (field) => (event) => {
    this.setState({
      pocForm: {
        ...this.state.pocForm,
        [field]: event.target.value,
      },
    });
  };

  handleCountryChange = (event, newValue) => {
    if (newValue) {
      this.setState({
        pocForm: {
          ...this.state.pocForm,
          countryCode: newValue.dialCode,
        },
      });
    }
  };

  handleOpenModal = (editingPoc = null) => {
    if (editingPoc) {
      // Extract phone number without country code
      const phoneNumber = editingPoc.number.replace(editingPoc.countryCode, "");
      this.setState({
        isModalOpen: true,
        editingPoc,
        pocForm: {
          name: editingPoc.name,
          designation: editingPoc.designation,
          email: editingPoc.email,
          phone: phoneNumber,
          countryCode: editingPoc.countryCode,
        },
      });
    } else {
      this.setState({
        isModalOpen: true,
        editingPoc: null,
        pocForm: {
          name: "",
          designation: "",
          email: "",
          phone: "",
          countryCode: "+91",
        },
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      isModalOpen: false,
      editingPoc: null,
      pocForm: {
        name: "",
        designation: "",
        email: "",
        phone: "",
        countryCode: "+91",
      },
    });
  };

  handleSavePOC = async () => {
    const { pocForm, pocs, editingPoc } = this.state;

    // Validate form
    if (
      !pocForm.name.trim() ||
      !pocForm.designation.trim() ||
      !pocForm.email.trim() ||
      !pocForm.phone.trim()
    ) {
      this.setState({
        alert: "error",
        alertMessage: "Please fill in all fields",
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(pocForm.email)) {
      this.setState({
        alert: "error",
        alertMessage: "Please enter a valid email address",
      });
      return;
    }

    // Phone validation
    const phoneRegex = /^[0-9+\-\s()]+$/;
    if (!phoneRegex.test(pocForm.phone)) {
      this.setState({
        alert: "error",
        alertMessage: "Please enter a valid phone number",
      });
      return;
    }

    try {
      this.setState({ loading: true });

      // Create updated pocs array
      let updatedPocs = [...pocs];

      if (editingPoc) {
        // Update existing POC
        const pocIndex = updatedPocs.findIndex((poc) => poc === editingPoc);
        if (pocIndex !== -1) {
          updatedPocs[pocIndex] = {
            name: pocForm.name,
            email: pocForm.email,
            countryCode: pocForm.countryCode,
            number: pocForm.phone,
            designation: pocForm.designation,
          };
        }
      } else {
        // Add new POC
        updatedPocs.push({
          name: pocForm.name,
          email: pocForm.email,
          countryCode: pocForm.countryCode,
          number: pocForm.phone,
          designation: pocForm.designation,
        });
      }

      const requestBody = {
        pocs: updatedPocs,
      };

      const response = await axios.post(
        `${URL}/api/update-form-pocs`,
        requestBody
      );

      // Refresh the POC list
      await this.fetchPOCs();

      this.setState({
        pocForm: {
          name: "",
          designation: "",
          email: "",
          phone: "",
          countryCode: "+91",
        },
        alert: "success",
        alertMessage: editingPoc
          ? "POC updated successfully!"
          : "POC added successfully!",
        isModalOpen: false,
        editingPoc: null,
      });
    } catch (error) {
      console.error("Error saving POC:", error);
      this.setState({
        alert: "error",
        alertMessage:
          error?.response?.data?.message ||
          "Failed to save POC. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleDeletePOC = async (pocToDelete) => {
    try {
      this.setState({ loading: true });

      // Remove the POC from the array
      const updatedPocs = this.state.pocs.filter((poc) => poc !== pocToDelete);

      const requestBody = {
        pocs: updatedPocs,
      };

      const response = await axios.post(
        `${URL}/api/update-form-pocs`,
        requestBody
      );

      // Refresh the POC list
      await this.fetchPOCs();

      this.setState({
        alert: "success",
        alertMessage: "POC deleted successfully!",
      });
    } catch (error) {
      console.error("Error deleting POC:", error);
      this.setState({
        alert: "error",
        alertMessage: "Failed to delete POC. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  onSnackbarClose = () => {
    this.setState({ alert: "", alertMessage: "" });
  };

  getSelectedCountry = () => {
    const { countryCode } = this.state.pocForm;
    return (
      dialCodes.find((country) => country.dialCode === countryCode) || null
    );
  };

  render() {
    const { classes, partner } = this.props;
    const {
      pocForm,
      alert,
      alertMessage,
      isModalOpen,
      loading,
      pocs,
      editingPoc,
    } = this.state;
    const selectedCountry = this.getSelectedCountry();

    return (
      <div className={classes.root}>
        <Header businessTitle={"POC Details"} />

        <Box my={3} />

        {/* POC List */}
        <div className={classes.contentContainer}>
          <Typography variant="h4" className={classes.sectionTitle}>
            POC List ({pocs.length}/10)
          </Typography>

          <div className={classes.pocGrid}>
            {/* POC Cards */}
            {pocs.map((poc, index) => (
              <Card className={classes.pocCard} key={index}>
                <CardContent>
                  <div className={classes.cardHeader}>
                    <Avatar className={classes.avatar}>
                      {poc.name.substring(0, 1).toUpperCase()}
                    </Avatar>
                    <div className={classes.actionButtons}>
                      <IconButton
                        size="small"
                        onClick={() => this.handleOpenModal(poc)}
                        className={classes.editButton}
                        disabled={loading}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => this.handleDeletePOC(poc)}
                        className={classes.deleteButton}
                        disabled={loading}
                      >
                        <Delete />
                      </IconButton>
                    </div>
                  </div>

                  <Typography variant="h6" className={classes.pocName}>
                    {poc.name}
                  </Typography>

                  <div className={classes.infoRow}>
                    <Business className={classes.icon} />
                    <Typography variant="body2" color="textSecondary">
                      {poc.designation}
                    </Typography>
                  </div>

                  <div className={classes.infoRow}>
                    <Email className={classes.icon} />
                    <Typography variant="body2" color="textSecondary">
                      {poc.email}
                    </Typography>
                  </div>

                  <div className={classes.infoRow}>
                    <Phone className={classes.icon} />
                    <Typography variant="body2" color="textSecondary">
                      {poc.countryCode} {poc.number}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            ))}

            {/* Add POC Card */}
            {pocs.length < 10 && (
              <Card
                className={classes.addPocCard}
                onClick={() => this.handleOpenModal()}
                style={{ cursor: "pointer" }}
              >
                <CardContent className={classes.addPocContent}>
                  <Add className={classes.addIcon} />
                  <Typography variant="h6" className={classes.addPocText}>
                    Add New POC
                  </Typography>
                </CardContent>
              </Card>
            )}
          </div>

          {pocs.length === 0 && !loading && (
            <div className={classes.emptyState}>
              <Typography variant="body1" color="textSecondary">
                No POCs added yet. Click the "Add New POC" card to get started.
              </Typography>
            </div>
          )}

          {loading && (
            <div className={classes.emptyState}>
              <Typography variant="body1" color="textSecondary">
                Loading...
              </Typography>
            </div>
          )}
        </div>

        {/* Add/Edit POC Modal */}
        <Dialog
          open={isModalOpen}
          onClose={this.handleCloseModal}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h3">
              {editingPoc ? "Edit POC" : "Add New POC"}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <div className={classes.modalForm}>
              <div className={classes.formRow}>
                <TextField
                  fullWidth
                  label="Name"
                  value={pocForm.name}
                  onChange={this.handleInputChange("name")}
                  variant="outlined"
                  required
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Designation"
                  value={pocForm.designation}
                  onChange={this.handleInputChange("designation")}
                  variant="outlined"
                  required
                  margin="normal"
                />
              </div>
              <div className={classes.formRow}>
                <TextField
                  fullWidth
                  label="Email ID"
                  type="email"
                  value={pocForm.email}
                  onChange={this.handleInputChange("email")}
                  variant="outlined"
                  required
                  margin="normal"
                />
              </div>
              <div className={classes.formRow}>
                <Autocomplete
                  options={dialCodes}
                  getOptionLabel={(option) =>
                    `${option.dialCode} (${option.name})`
                  }
                  value={selectedCountry}
                  onChange={this.handleCountryChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country Code"
                      variant="outlined"
                      required
                      margin="normal"
                    />
                  )}
                  fullWidth
                />
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={pocForm.phone}
                  onChange={this.handleInputChange("phone")}
                  variant="outlined"
                  required
                  margin="normal"
                  placeholder="Enter phone number without country code"
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseModal}
              color="primary"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleSavePOC}
              color="primary"
              variant="contained"
              startIcon={<Add />}
              disabled={loading}
            >
              {loading
                ? editingPoc
                  ? "Updating..."
                  : "Adding..."
                : editingPoc
                ? "Update POC"
                : "Add POC"}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={!!alert}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={this.onSnackbarClose}
        >
          <Alert severity={alert} onClose={this.onSnackbarClose}>
            {alertMessage}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    height: "100%",
    width: "100%",
    background: "rgb(249,249,249)",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0.5em",
    },
  },
  addPocCard: {
    flex: "0 0 calc(33.333% - 16px)",
    maxWidth: "338px",
    minWidth: "270px",
    minHeight: "205px",
    border: `2px dashed ${theme.palette.primary.main}`,
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.light + "10",
      borderColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down("sm")]: {
      flex: "0 0 calc(50% - 12px)",
    },
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 100%",
    },
  },
  addPocContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    paddingBottom: "12px",
  },
  addIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  addPocText: {
    fontSize: "1rem",
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 2em",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1em",
    },
  },
  sectionTitle: {
    marginBottom: "1em",
    alignSelf: "flex-start",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
  pocGrid: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: "24px",
    width: "100%",
    maxWidth: "1200px",
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    paddingBottom: "24px",
    marginBottom: "48px",
  },
  pocCard: {
    flex: "0 0 calc(33.333% - 16px)",
    maxWidth: "350px",
    minWidth: "280px",
    height: "fit-content",
    [theme.breakpoints.down("sm")]: {
      flex: "0 0 calc(50% - 12px)",
    },
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 100%",
    },
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  actionButtons: {
    display: "flex",
    gap: "4px",
  },
  editButton: {
    color: theme.palette.info.main,
  },
  avatar: {
    backgroundColor: theme.palette.primary.secondary,
    color: theme.palette.primary.contrastText,
    fontSize: "1.5rem",
    height: "3rem",
    width: "3rem",
  },
  pocName: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  icon: {
    fontSize: "1rem",
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
    width: "100%",
  },
  modalForm: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  formRow: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
});

const connectedPOCDetailsPage = connect((state) => ({
  partner: state.partner.partner,
}))(POCDetailsPage);

export default withStyles(styles)(connectedPOCDetailsPage);
